/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDeselectList = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m7.702 17.712-1.297 1.28 1.302 1.301-1.414 1.414-1.31-1.31-1.28 1.264-1.405-1.423 1.27-1.256-1.275-1.275 1.414-1.414 1.284 1.284 1.307-1.289zM22 20H10v-2h12zM7.702 10.712l-1.297 1.28 1.302 1.301-1.414 1.414-1.31-1.31-1.28 1.264-1.405-1.423 1.27-1.256-1.275-1.275 1.414-1.414 1.284 1.284 1.307-1.289zM22 13H10v-2h12zM7.702 3.712l-1.297 1.28 1.302 1.301-1.414 1.414-1.31-1.31-1.28 1.264-1.405-1.423 1.27-1.256-1.275-1.275 1.414-1.414 1.284 1.284 1.307-1.289zM22 6H10V4h12z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDeselectList as DeselectList };
